import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IFacilityWarehouse } from 'app/shared/model/facility-warehouse.model';
import { getEntities } from './facility-warehouse.reducer';

export const FacilityWarehouse = () => {
  const dispatch = useAppDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const facilityWarehouseList = useAppSelector(state => state.facilityWarehouse.entities);
  const loading = useAppSelector(state => state.facilityWarehouse.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  return (
    <div>
      <h2 id="facility-warehouse-heading" data-cy="FacilityWarehouseHeading">
        <Translate contentKey="integrawebApp.facilityWarehouse.home.title">Facility Warehouses</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="integrawebApp.facilityWarehouse.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/facility-warehouse/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="integrawebApp.facilityWarehouse.home.createLabel">Create new Facility Warehouse</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {facilityWarehouseList && facilityWarehouseList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="integrawebApp.facilityWarehouse.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.facilityWarehouse.stdwaein">Stdwaein</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.facilityWarehouse.stdwaaus">Stdwaaus</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.facilityWarehouse.stdqs">Stdqs</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.facilityWarehouse.createdDate">Created Date</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.facilityWarehouse.createdBy">Created By</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.facilityWarehouse.lastModifiedDate">Last Modified Date</Translate>
                </th>
                <th>
                  <Translate contentKey="integrawebApp.facilityWarehouse.lastModifiedBy">Last Modified By</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {facilityWarehouseList.map((facilityWarehouse, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/facility-warehouse/${facilityWarehouse.id}`} color="link" size="sm">
                      {facilityWarehouse.id}
                    </Button>
                  </td>
                  <td>{facilityWarehouse.stdwaein ? 'true' : 'false'}</td>
                  <td>{facilityWarehouse.stdwaaus ? 'true' : 'false'}</td>
                  <td>{facilityWarehouse.stdqs ? 'true' : 'false'}</td>
                  <td>
                    {facilityWarehouse.createdDate ? (
                      <TextFormat type="date" value={facilityWarehouse.createdDate} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{facilityWarehouse.createdBy}</td>
                  <td>
                    {facilityWarehouse.lastModifiedDate ? (
                      <TextFormat type="date" value={facilityWarehouse.lastModifiedDate} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{facilityWarehouse.lastModifiedBy}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/facility-warehouse/${facilityWarehouse.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/facility-warehouse/${facilityWarehouse.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/facility-warehouse/${facilityWarehouse.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="integrawebApp.facilityWarehouse.home.notFound">No Facility Warehouses found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default FacilityWarehouse;
